<template>
  <div class="z-60 h-screen fixed w-screen pointer-events-none">
    <div
      class="h-screen w-screen fixed top-0 popup-bg left-0 z-40"
      :class="{ 'popup-bg--show': show }"
      @click="close"
    ></div>
    <div
      class="
        bg-white
        fixed
        left-1/2
        top-1/2
        z-60
        -translate-x-1/2
        transform
        -translate-y-1/2
        min-w-96
        h-auto
        rounded-3xl
        flex
        items-center
        justify-center
        px-8
        relative
        transform
        scale-0
        popup
        overflow-x-hidden
        pointer-events-auto
      "
      :class="{
        'overflow-y-auto scale-100 popup--show': show
      }"
    >
      <div class="flex-grow flex flex-col justify-between py-8 h-full">
        <div v-if="typeof message === 'string'" class="mb-6">
          <div >
            <p class="mb-4 text-grey-2 font-bold text-lg mr-2 md:mr-0 mt-2">
              {{ $t('errors.api.' + message + '.title') }}
            </p>
            <img 
              src="@/assets/svg/cross.svg"
              class="absolute right-8 top-8 cursor-pointer"
              @click="close"
              alt=""
            />
          </div>
          <p
            class="text-grey-2 text-sm w-10/12 mx-auto"
            v-if="error"
            v-html="
              $t('errors.api.' + message + '.description', {
                value: error.response.data.value
              })
            "
          />
        </div>
        <div v-else-if="message && message.length" class="mb-4">
          <p class="mb-6 text-grey-2 font-bold text-lg">
            {{ $t('errors.api.general_error.title') }}
          </p>
          <p
            class="text-grey-2 text-sm"
            v-for="error in message"
            v-bind:key="error.code"
          >
            {{
              $t('errors.api.' + error.code + '.description', {
                value: error.value
              })
            }}
          </p>
        </div>
        <div
          v-else-if="
            message &&
            typeof message === 'object' &&
            !Array.isArray(message) &&
            message !== null
          "
          class="mb-4"
        >
          <p class="mb-6 text-grey-2 font-bold text-lg">
            {{ $t('errors.api.' + message.code + '.title') }}
          </p>
          <p class="text-grey-2 text-sm">
            {{
              $t('errors.api.' + message.code + '.description', {
                value: message.value
              })
            }}
          </p>
        </div>
        <div v-else class="mb-6">
          <p class="mb-6 text-grey-2 font-bold text-lg">
            {{ $t('errors.api.fallback.title') }}
            <img
              src="@/assets/svg/cross.svg"
              class="absolute right-8 top-8 cursor-pointer"
              @click="close"
              alt=""
            />
          </p>
          <p class="text-grey-2 text-sm w-10/12 mx-auto" v-if="error">
            {{ $t('errors.api.fallback.description') }}
          </p>
        </div>
        <button class="fat-btn-orange-full cursor-pointer" @click="close">
          {{ $t('errors.try_again') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import useError from '@/mixins/useError.js'
export default {
  props: {
    show: Boolean
  },
  setup() {
    const store = useStore()
    const router = useRouter()
    const { serverError, errorMessage } = useError()

    const message = computed(() => {
      return errorMessage()
    })

    const redirect = computed(() => {
      return store.state.error ? store.state.error.redirect : ''
    })

    const error = computed(() => {
      return store.state.error
        ? serverError(store.state.error.error)
          ? null
          : store.state.error.error
        : null
    })

    const close = () => {
      const dest = redirect.value
      store.dispatch('clearError')
      if (dest) router.push(dest)
    }

    return {
      error,
      close,
      message,
      redirect
    }
  }
}
</script>
<style scoped>
.popup {
  max-width: 30rem;
  transition: all 0.2s ease-in-out;
  opacity: 0;
}

.popup--side {
  transform: translate(-50%, 0%) scale(1);
}

@media (min-width: 768px) {
  .popup--side {
    transform: translate(200%, 0%);
    border-radius: 0;
  }

  .popup--show {
    transform: translate(-50%, -50%);
    opacity: 1;
  }

  .popup--show-side {
    transform: translate(0%, 0%);
    pointer-events: all;
    opacity: 1;
  }
}

.popup-bg {
  background-color: rgba(79, 89, 99, 0);
  transition: all 0.2s ease-in-out;
  pointer-events: none;
  backdrop-filter: blur(0px);
}
.popup-bg--show {
  pointer-events: all;
  display: block;
  backdrop-filter: blur(2px);
  background-color: rgba(79, 89, 99, 0.8);
}

.max-h-content {
  max-height: calc(100vh - 14rem);
}

@media (max-width: 768px) {
  .popup--show-side {
    transform: translate(-50%, -30%);
    pointer-events: all;
    opacity: 1;
  }
  .max-h-content {
    max-height: calc(100vh - 20rem);
  }
  .popup--show {
    pointer-events: all;
    opacity: 1;
    transform: translate(-50%, -40%);
  }
}
</style>